import { render, staticRenderFns } from "./NotifPostInCommunity.vue?vue&type=template&id=330455c0&scoped=true"
import script from "./NotifPostInCommunity.vue?vue&type=script&lang=js"
export * from "./NotifPostInCommunity.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=330455c0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330455c0",
  null
  
)

export default component.exports